import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

function BenefitsCard(props: IBenefitsCard) {
  const { title, img, text, as } = props;

  let imgProps;
  let Text;

  if (typeof img === "object") {
    imgProps = { ...img };
  } else {
    imgProps = {
      src: img,
    };
  }

  if (Array.isArray(text)) {
    Text = text.map((e, index) => <CardText key={index}>{e}</CardText>);
  } else {
    Text = <CardText>{text}</CardText>;
  }

  return (
    <Wrapper as={as}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardLogo>
          <Logo {...imgProps} />
        </CardLogo>
      </CardHeader>
      <CardBody>{Text}</CardBody>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  max-width: 331px;
  background-color: var(--color-brand-bg-secondary);
  padding: 30px;
  border-radius: 15px;
  min-height: 407px;
  display: flex;
  flex-wrap: wrap;
`;

const CardHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  align-self: flex-start;
  min-height: 84px;
`;

const CardTitle = styled.h2`
  font-size: 1.438rem;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 25.42px;
  border-left: 2px solid var(--color-brand-grey-main);
  padding-left: 8.5px;
  min-height: 45px;
  width: 75%;
  margin-bottom: 0;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-transform: none;
  @media screen and (max-width: 991px) {
    text-align: center;
  }
`;

const CardLogo = styled.div`
  max-width: 69px;
`;

const Logo = styled.img`
  width: 100%;
  border-style: none;
`;

const CardBody = styled.div`
  width: 100%;
  align-self: stretch;
`;

const CardText = styled.p`
  font-size: 0.938rem;
  color: #616161;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 15px;
  width: 100%;
`;

interface IBenefitsCard {
  title: string;
  img: ImageShape | string;
  text: string | Array<string>;
  as: React.ElementType;
}

interface ImageShape {
  src: string | undefined;
}

export default BenefitsCard;
